<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.create_title')"
  :rightActions="rightActions"
)
  UiFormGroup(
    :label="$t('companies.basic.name')"
    :vuelidateModel="v$.form.company_name"
  )
    UiInput#company-name-input(
      v-model="form.company_name"
      :error="v$.form.company_name.$error"
    )
  UiFormGroup(
    :label="$t('companies.basic.netvisor_organization_id')"
    :vuelidateModel="v$.form.netvisor_organization_id"
  )
    UiInput#business-id-input(
      v-model="form.netvisor_organization_id"
      :error="v$.form.netvisor_organization_id.$error"
    )
  UiFormGroup(
    :label="$t('companies.basic.reseller')"
    :vuelidateModel="v$.form.reseller_id"
  )
    UiMultiselect(
      v-model="form.reseller_id"
      :options="resellers"
      label="text"
      :error="v$.form.reseller_id.$error"
      :canClear="false"
      :canDeselect="false"
    )
</template>

<script>
import Company from "@/models/Company";
import ApiCompanies from "@/api/companies.js";
import ApiResellers from "@/api/resellers.js";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        company_name: {
          required,
        },
        netvisor_organization_id: {
          required,
        },
        reseller_id: {
          required,
        },
      },
    };
  },

  data() {
    return {
      show: false,
      form: new Company(),
      resellers: [],
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    open(company) {
      this.v$.$reset();
      this.form = new Company(company);
      this.show = true;
      ApiResellers.fetchResellers({ sortBy: "name", per_page: 9999 }).then(
        (resp) => {
          this.resellers = resp.data.resellers.map((res) => {
            return { value: res.id, text: res.name };
          });
        },
      );
    },

    close() {
      this.show = false;
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) return;
        const form = this.form;
        const params = {
          company_name: form.company_name,
          netvisor_organization_id: form.netvisor_organization_id,
          reseller_id: form.reseller_id,
        };
        ApiCompanies.createCompany(params)
          .then((result) => {
            this.$emit("done");
            this.close();
          })
          .catch((error) => {});
      });
    },
  },
};
</script>
